import React, { useEffect, useState } from "react";
import {
  Collapse, Button, Form, Input, Select, Row, Col
} from "antd";
import { QuestionCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import globalData from "../../config/global_data";

const { Panel } = Collapse;

const ProductItem = ({ products, product, onRemove, onUpdate, setInnerProducts, index, form }) => {
  const [selectedSKU, setSelectedSKU] = useState([]);
  const [options, setOptions] = useState([]);
  const [data, setData] = useState(null);

  useEffect(() => {  
    
    if (product) {
      setData(product)
      if (globalData && globalData?.bc_sku_list?.length > 0) {
        let optionsdata = globalData.bc_sku_list.filter(item => item.store_id === product.store_id)
        setOptions(optionsdata);
        if (product.name) {
          setSelectedSKU(product.value);
        }
      }
    } else {
      if (globalData && globalData?.bc_sku_list?.length > 0) {
        let optionsdata = globalData.bc_sku_list.filter(item => item.store_id === product.store_id)
        setOptions(optionsdata);
      }
    }
  }, []);
  useEffect(() => {
    if (data) {
      let updated_products = products.map(item =>
        item.id === product.id ? { ...item, ...data } : item
      );
      setInnerProducts(updated_products);
    }
  }, [data, setInnerProducts]);

  const handleNameChange = (e) => {
    const trimmedValue = e.target.value.trim();
    setData({ ...data, name: trimmedValue })
    onUpdate(product.id, { name: trimmedValue });
  };

  const handleChange = async (value) => {
    try {
      setSelectedSKU(value);

      const selecteddata = options.find(item => item.value == value);
      if (selecteddata) {
        let updatedData = {
          ...data,
          name: selecteddata.product_name,
          value: value,
          store_id: product.store_id
        };
        setData(updatedData);
        onUpdate(product.id, updatedData);
      }
    } catch (error) {
      console.error("handleChange error:", error);
    }
  };

  return (
    
    <Collapse
      items={[
        {
          key: product.id,
          label: product.name,
          className: "ProductDetailsCollapse_inner",
          children: (
            data && data.editable && (
              <>
                <Form.Item
                  label="Product Name"
                  name={`pname_${product.id}`}
                  rules={[{ required: true, whitespace: true, message: "Please enter Product name" }]}
                  initialValue={data.name}
                >
                  <Input
                    placeholder="New Product"
                    value={data.name}
                    onChange={handleNameChange}                    
                  />
                </Form.Item>

                <Form.Item
                  label="SKU"
                >
                  <Select
                    showSearch
                    optionFilterProp="label"
                    style={{ width: "100%" }}
                    placeholder="Select SKU"
                    onChange={handleChange}
                    options={options}
                    value={selectedSKU}
                    disabled
                  />
                </Form.Item>

                <Row gutter={8}>
                  <Col span={12}>
                    <Form.Item
                      label="Quantity"
                    >
                      <Input type="number" placeholder="1" value={data.qty}  disabled/>
                    </Form.Item>
                  </Col>
                </Row>               
              </>
            )
          )
        }
      ]}
    />
  );
};

export default ProductItem;
